export default {
  FETCH_NEXT_LIST: "FETCH_NEXT_LIST",
  FETCH_NEXT_LIST_TYPE: "FETCH_NEXT_LIST_TYPE",
  FETCH_NEXT_LIST_TYPE_DONE: "FETCH_NEXT_LIST_TYPE_DONE",
  FETCH_NEXT_LIST_DONE: "FETCH_NEXT_LIST_DONE",
  FETCH_SUBTYPES: "FETCH_SUBTYPES",
  FETCH_SUBTYPES_DONE: "FETCH_SUBTYPES_DONE",
  FILTER_LIST: "FILTER_LIST",
  FILTER_LIST_DONE: "FILTER_LIST_DONE",
  INIT_LIST: "INIT_LIST",
  INFINITE_SCROLL_LIST: "INFINITE_SCROLL_LIST",
  SHOW_PRICES: "SHOW_PRICES",
  AVAILABILITY_ERROR: "AVAILABILITY_ERROR",
  SELECT_DATES: "SELECT_DATES",
  TOGGLE_TAKEOVER: "TOGGLE_TAKEOVER",
  CLEAR_LIST: "CLEAR_LIST",
  FETCH_LIST: "FETCH_LIST",
  FETCH_LIST_DONE: "FETCH_LIST_DONE",
};



// WEBPACK FOOTER //
// ./assets/list/constants/actions.js